module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "flex space-between top-header"
  }, [_c('div', {
    staticClass: "header__left-menu"
  }, [_c('a', {
    staticClass: "flex hide-desktop",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-end stretch top-menu"
  }, [(_vm.hasModule('Appointment')) ? _c('router-link', {
    staticClass: "top-menu_item flex",
    attrs: {
      "to": "/members?tab=calendar&data=bookings"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('el-switch', {
    attrs: {
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    on: {
      "change": _vm.toggleDebugMode
    },
    model: {
      value: (_vm.debugMode),
      callback: function($$v) {
        _vm.debugMode = $$v
      },
      expression: "debugMode"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    staticClass: "top-menu_item flex",
    attrs: {
      "hide-on-click": true,
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('span', {
    staticClass: "user-avatar"
  }, [(_vm.avatar) ? _c('img', {
    attrs: {
      "alt": "",
      "src": _vm.avatar
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.avatar) ? _c('img', {
    attrs: {
      "alt": "",
      "src": require("../../../assets/images/user-avatar.jpg")
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    staticClass: "top-menu_item flex",
    attrs: {
      "to": {
        name: 'profile.account'
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$t('layouts.sidebar.settings')) + "\n          ")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
    staticClass: "top-menu_item flex",
    attrs: {
      "to": {
        name: 'modules.index'
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" \n            " + _vm._s(_vm.$t('layouts.sidebar.modules')) + "\n          ")])], 1), _vm._v(" "), _vm._l((_vm.organizations), function(organization) {
    return _c('el-dropdown-item', [_c('a', {
      staticClass: "top-menu_item flex",
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.switchOrganization($event)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-exchange"
    }), _vm._v("  " + _vm._s(_vm.$t('layouts.sidebar.switchToOrganization')) + " " + _vm._s(organization.name))])])
  }), _vm._v(" "), _c('el-dropdown-item', [_c('a', {
    staticClass: "top-menu_item flex",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("  " + _vm._s(_vm.$t('layouts.sidebar.logout')))])])], 2)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a1ce3aa","hasScoped":false}!./src/app/components/header/header.html
// module id = 3095
// module chunks = 1